import "selectric";
import Helpers from "../utils/helpers";

const templateDiasporaForm = {
  formEl: null,

  init() {
    this.register();
    this.events();
    this.handleSelectric();
  },

  register() {
    this.formEl = $(".diaspora-form");

    if (!this.formEl.length) {
      return;
    }
  },

  events() {
    $(window).on("resize", () => {
      this.handleSelectric();
    });

    // Add social.
    $(".social-box__add").on("click", function (e) {
      e.preventDefault();

      templateDiasporaForm.handleAddSocial();
    });

    // Remove social.
    $("body").on("click", ".social-box-item__remove", function (e) {
      e.preventDefault();

      const id = $(this).data("remove");
      const socials = JSON.parse($('[name="socials"]').val());

      const newSocials = socials.filter((social) => {
        return social.id !== id;
      });

      $('[name="socials"]').val(JSON.stringify(newSocials)).trigger("change");
    });

    // Render socials.
    $('[name="socials"]').on("change", function () {
      templateDiasporaForm.renderSocials();
    });

    // Submit form.
    $(".diaspora-form").on("submit", (e) => {
      e.preventDefault();
      const formEl = $(e.currentTarget);

      formEl.addClass("loading");

      formEl.find('[type="submit"]').prop("disabled", true);

      if (Helpers.validate(formEl, false)) {
        grecaptcha.ready(() => {
          grecaptcha
            .execute(Sage.recaptcha_key, { action: "submit" })
            .then((token) => {
              templateDiasporaForm.submit(token);
            });
        });
      } else {
        $(".diaspora-form__content").animate(
          {
            scrollTop: 0,
          },
          250
        );

        formEl.removeClass("loading");
        formEl.find('[type="submit"]').prop("disabled", false);
      }
    });
  },

  handleSelectric() {
    const countrySelect = $("[name=country]").data("selectric");
    const socialTypeSelect = $("[name=social-type]").data("selectric");

    if ($(window).width() < 768) {
      if (countrySelect) {
        countrySelect.destroy();
      }
      if (socialTypeSelect) {
        socialTypeSelect.destroy();
      }
    } else {
      if (!countrySelect) {
        $("[name=country]").selectric();
      }
      if (!socialTypeSelect) {
        $("[name=social-type]").selectric();
      }
    }
  },

  handleAddSocial() {
    const solcialsEl = $('[name="socials"]');
    const typeEl = this.formEl.find("[name=social-type]");
    const nameEl = this.formEl.find("[name=social-name]");

    if (typeEl.val() === "") {
      typeEl.addClass("error");
    } else {
      typeEl.removeClass("error");
    }

    typeEl
      .closest(".selectric-wrapper")
      .find(".selectric")
      .toggleClass("error", typeEl.val() === "");

    if (nameEl.val() === "") {
      nameEl.addClass("error");
    } else {
      nameEl.removeClass("error");
    }

    if (typeEl.hasClass("error") || nameEl.hasClass("error")) {
      return;
    }

    let socials = [];
    if (solcialsEl.val()) {
      socials = JSON.parse(solcialsEl.val());
    }

    const social = {
      id: Math.random().toString(36).substr(2, 9),
      type: typeEl.val(),
      name: nameEl.val(),
    };

    socials.push(social);

    solcialsEl.val(JSON.stringify(socials)).trigger("change");

    // Reset form
    typeEl.val("");
    nameEl.val("");
  },

  renderSocials() {
    const selectedEl = $(".social-box__selected");

    selectedEl.html("");

    let socials = JSON.parse($('[name="socials"]').val());

    let html = "";

    for (let index = 0; index < socials.length; index++) {
      const social = socials[index];

      html += `<div class="social-box-item">
        ${Sage.icons.social[social.type]}
        <div class="social-box-item__name">${social.name}</div>
        <button class="social-box-item__remove" type="button" data-remove="${social.id
        }">
          ${Sage.icons.closecircle}
        </button>
      </div>`;
    }

    selectedEl.append(html);
  },

  submit(token) {
    const formEl = $(".diaspora-form");
    const tyPage = $('#tyPage').data('ty');
    console.log(tyPage);
    formEl.find(".form-status").addClass("hidden");

    // Data.
    const formData = new FormData(formEl[0]);

    formData.append("token", token);

    $.ajax({
      url: Sage.ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();

          formEl.find(".form-status").removeClass("error");
          if (tyPage.length) {
            window.location.replace(tyPage);
          }
        } else {
          formEl.find(".form-status").addClass("error");
          formEl
            .find(".form-status")
            .text(response.data.message)
            .removeClass("hidden");
        }


      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find('[type="submit"]').prop("disabled", false);
      });
  },
};

export default templateDiasporaForm;
